import React from "react";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';

// ANTEPRIMA: segni grafici comuni alle pagine di anteprima (Card, DettaglioCard).
// La pagina resta identica alla card reale (SpecificCard / FinalEnd); in più ha
// una fascia "BOZZA" in alto e la scritta BOZZA in filigrana su tutto il contenuto.

const svgFiligrana =
    "<svg xmlns='http://www.w3.org/2000/svg' width='440' height='280'>" +
    "<text x='220' y='140' text-anchor='middle' dominant-baseline='middle' transform='rotate(-30 220 140)' " +
    "font-family='Arial, Helvetica, sans-serif' font-size='68' font-weight='700' letter-spacing='10' " +
    "fill='#F57C00' fill-opacity='0.09'>BOZZA</text></svg>";

// Livello sopra il contenuto, trasparente ai click e alla selezione del testo.
// Va messo come ultimo figlio di un contenitore con position: relative.
export const filigranaBozza = {
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    userSelect: "none",
    zIndex: 1,
    backgroundImage: "url(\"data:image/svg+xml;utf8," + encodeURIComponent(svgFiligrana) + "\")",
    backgroundRepeat: "repeat",
    WebkitPrintColorAdjust: "exact",
    printColorAdjust: "exact",
};

export function BannerBozza() {
    return (
        <div role="note"
            style={{
                display: "flex", alignItems: "center", gap: "12px",
                textAlign: "left",
                background: "#F6BD60", color: "black",
                border: "2px dashed #F57C00", borderRadius: "8px",
                padding: "10px 20px", margin: "0px 0px 10px 0px",
                WebkitPrintColorAdjust: "exact", printColorAdjust: "exact",
            }}>
            <DriveFileRenameOutlineIcon />
            <div>
                <p className="text" style={{ margin: 0, fontWeight: "bold", letterSpacing: "1px" }}>
                    BOZZA – ANTEPRIMA DELLA SCHEDA
                </p>
                <p className="text" style={{ margin: 0, fontSize: "14px" }}>
                    I contenuti possono ancora cambiare. La versione ufficiale è quella pubblicata nel fascicolo.
                </p>
            </div>
        </div>
    );
}
